export function createSubmitEstablishmentObject(establishment,
                                         filingYear,
                                         resubmissionReason) {
  let establishmentToSubmit = {
    establishment_id: establishment.id,
    year_filing_for: filingYear,
    submission_method: 1
  };
  if (resubmissionReason) {
    establishmentToSubmit.resubmission_reason = resubmissionReason;
  }
  return establishmentToSubmit;
}



/** WEBPACK FOOTER **
 ** ./src/components/establishment/EstablishmentSubmissionObject.js
 **/